// ─── Centralised runtime config + shared constants ──────────
// Values can be overridden via environment variables (REACT_APP_* for CRA).
// NOTE: REACT_APP_* values are baked into the client bundle at build time.
// A publishable key may ship in the client, but authorization still requires
// authenticated roles, explicit grants, and RLS. See docs/ARCHITECTURE.md.

export const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || "https://vxhmkwhqtcnetwkmgbqk.supabase.co";

export const SUPABASE_KEY =
  process.env.REACT_APP_SUPABASE_KEY || "sb_publishable_2nSthGgw2TutRxQ39TJplw_YipkpaEb";

// UI gate only — NOT a real security boundary (visible in the JS bundle).
// Real data protection must come from Auth, grants, and RLS.
export const ACCESS_PASSWORD =
  process.env.REACT_APP_ACCESS_PASSWORD || "Optiver123";

export const APAC_LOCATIONS = ['Hong Kong','Sydney','Singapore','Shanghai','Mumbai','Tokyo','Seoul','Gurugram','Taipei','Beijing','Shenzhen'];

const APAC_LOC_GROUP = { 'Mumbai': 'India', 'Gurugram': 'India' };

export const groupLoc = (loc) => {
  const city = APAC_LOCATIONS.find(a => loc?.includes(a)) || 'Other';
  return APAC_LOC_GROUP[city] || city;
};

// Headlines/sources that are never relevant to prop-trading intelligence.
// (Safety net — relevance is primarily controlled at upload time, before
// rows reach Supabase; this filter catches anything that slips through.)
export const JUNK_KEYWORDS = ['missing person','police service','etoro','매일경제','limited public information','obituar'];
export const JUNK_SOURCES = ['매일경제','Toronto Police Service'];
// NOTE: 'weather'/'sports' are deliberately NOT junk keywords — they matched
// legitimate prediction-markets coverage (e.g. SIG/Citadel weather & event markets).

export const isRelevantNews = (n) => {
  if (!n.competitor_id) return false;
  const hl = (n.headline || '').toLowerCase();
  if (JUNK_KEYWORDS.some(k => hl.includes(k))) return false;
  if (JUNK_SOURCES.includes(n.source)) return false;
  return true;
};
